"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4FilterListType = void 0;
var GA4FilterListType;
(function (GA4FilterListType) {
    GA4FilterListType["ListView"] = "list view";
    GA4FilterListType["TileView"] = "tile view";
    GA4FilterListType["MapView"] = "map view";
    GA4FilterListType["MapViewMap"] = "map view set on map";
    GA4FilterListType["MapViewMenu"] = "map view set in filter menu";
    GA4FilterListType["ListViewMenu"] = "list view set in filter menu";
    GA4FilterListType["TileViewMenu"] = "tile view set in filter menu";
    GA4FilterListType["ListViewList"] = "list view set on list";
    GA4FilterListType["TileViewList"] = "tile view set on list";
    GA4FilterListType["ProviderList"] = "provider list";
})(GA4FilterListType || (exports.GA4FilterListType = GA4FilterListType = {}));
//# sourceMappingURL=GA4FilterListType.js.map